import { createContext, useContext, useState } from 'react';
import { UtrvConnection } from './types';
import { CurrentInputData } from '@g17eco/types/question';
import { EvidenceFile } from '@g17eco/types/file';

export type SelectedConnection = UtrvConnection | undefined;
type InputData = number | string | undefined;

interface ConnectionContextProps {
  utrvId?: string;
  isReadOnly?: boolean;
  connection: SelectedConnection;
  setConnection: (connection: UtrvConnection) => void;
  setInputData: (data: InputData) => void;
  inputData?: InputData;
  removeConnection: () => void;
  currentInputData: CurrentInputData;
  files: EvidenceFile[];
  setFiles: (addFiles: EvidenceFile[]) => void;
}

export const ConnectionContext = createContext<ConnectionContextProps>({
  utrvId: undefined,
  setConnection: (_connection) => {},
  connection: undefined,
  setInputData: (_data) => {},
  inputData: undefined,
  removeConnection: () => {},
  currentInputData: { table: { editRowId: -1, rows: [] }, valueData: {} },
  files: [],
  setFiles: (_addFiles) => {},
});

export const useConnectionContext = () => {
  return useContext(ConnectionContext);
};

interface Props
  extends Pick<ConnectionContextProps, 'currentInputData' | 'files' | 'setFiles' | 'utrvId' | 'isReadOnly'> {
  children: React.ReactNode;
}

export const ConnectionProvider = ({ children, currentInputData, setFiles, files, utrvId, isReadOnly }: Props) => {
  const [connection, setConnection] = useState<SelectedConnection>();
  const [inputData, setInputData] = useState<InputData>();

  const removeConnection = () => {
    setConnection(undefined);
    setInputData(undefined);
  };

  return (
    <ConnectionContext.Provider
      value={{
        utrvId,
        isReadOnly,
        connection,
        setConnection: (connection: UtrvConnection) => setConnection(connection),
        setInputData: (data: InputData) => setInputData(data),
        inputData,
        removeConnection,
        currentInputData,
        files,
        setFiles,
      }}
    >
      {children}
    </ConnectionContext.Provider>
  );
};
